module.exports = __webpack_public_path__ + "img/BN.19a741e2.svg";